// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAddressInfoDto } from './IAddressInfoDto';
import {
    IAddressInfoDtoFromJSON,
    IAddressInfoDtoFromJSONTyped,
    IAddressInfoDtoToJSON,
    IAddressInfoDtoToJSONTyped,
} from './IAddressInfoDto';
import type { IPersonInfoDto } from './IPersonInfoDto';
import {
    IPersonInfoDtoFromJSON,
    IPersonInfoDtoFromJSONTyped,
    IPersonInfoDtoToJSON,
    IPersonInfoDtoToJSONTyped,
} from './IPersonInfoDto';
import type { ICountryInfoDto } from './ICountryInfoDto';
import {
    ICountryInfoDtoFromJSON,
    ICountryInfoDtoFromJSONTyped,
    ICountryInfoDtoToJSON,
    ICountryInfoDtoToJSONTyped,
} from './ICountryInfoDto';

/**
 * 
 * @export
 * @interface IPersonAddressInfoDto
 */
export interface IPersonAddressInfoDto {
    /**
     * 
     * @type {IPersonInfoDto}
     * @memberof IPersonAddressInfoDto
     */
    person: IPersonInfoDto;
    /**
     * 
     * @type {IAddressInfoDto}
     * @memberof IPersonAddressInfoDto
     */
    address: IAddressInfoDto;
    /**
     * 
     * @type {ICountryInfoDto}
     * @memberof IPersonAddressInfoDto
     */
    citizenship_country?: ICountryInfoDto;
    /**
     * 
     * @type {Date}
     * @memberof IPersonAddressInfoDto
     */
    valid_from: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPersonAddressInfoDto
     */
    valid_to: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IPersonAddressInfoDto
     */
    preferred_mailing: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPersonAddressInfoDto
     */
    preferred_physical: boolean;
}

/**
 * Check if a given object implements the IPersonAddressInfoDto interface.
 */
export function instanceOfIPersonAddressInfoDto(value: object): value is IPersonAddressInfoDto {
    if (!('person' in value) || value['person'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('valid_from' in value) || value['valid_from'] === undefined) return false;
    if (!('valid_to' in value) || value['valid_to'] === undefined) return false;
    if (!('preferred_mailing' in value) || value['preferred_mailing'] === undefined) return false;
    if (!('preferred_physical' in value) || value['preferred_physical'] === undefined) return false;
    return true;
}

export function IPersonAddressInfoDtoFromJSON(json: any): IPersonAddressInfoDto {
    return IPersonAddressInfoDtoFromJSONTyped(json, false);
}

export function IPersonAddressInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPersonAddressInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'person': IPersonInfoDtoFromJSON(json['person']),
        'address': IAddressInfoDtoFromJSON(json['address']),
        'citizenship_country': json['citizenship_country'] == null ? undefined : ICountryInfoDtoFromJSON(json['citizenship_country']),
        'valid_from': (new Date(json['valid_from'])),
        'valid_to': (new Date(json['valid_to'])),
        'preferred_mailing': json['preferred_mailing'],
        'preferred_physical': json['preferred_physical'],
    };
}

export function IPersonAddressInfoDtoToJSON(json: any): IPersonAddressInfoDto {
    return IPersonAddressInfoDtoToJSONTyped(json, false);
}

export function IPersonAddressInfoDtoToJSONTyped(value?: IPersonAddressInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'person': IPersonInfoDtoToJSON(value['person']),
        'address': IAddressInfoDtoToJSON(value['address']),
        'citizenship_country': ICountryInfoDtoToJSON(value['citizenship_country']),
        'valid_from': ((value['valid_from']).toISOString()),
        'valid_to': ((value['valid_to']).toISOString()),
        'preferred_mailing': value['preferred_mailing'],
        'preferred_physical': value['preferred_physical'],
    };
}

